import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, int32_type, bool_type, string_type, option_type, obj_type, lambda_type, unit_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { GlobalMsg, UserSession_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { value as value_2, map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { newGuid } from "../../../fable_modules/fable-library-js.4.19.0/Guid.js";
import { containsKey } from "../../../fable_modules/fable-library-js.4.19.0/Map.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Page } from "../News/Types.fs.js";
import { empty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { equals, int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { DangerousHtml, DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { bfsTile } from "./Tile.fs.js";

export class PreviewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoPreview", "Desktop", "Mobile"];
    }
}

export function PreviewMode_$reflection() {
    return union_type("Shared.Banner.PreviewMode", [], PreviewMode, () => [[], [], []]);
}

export class BannerProps extends Record {
    constructor(GlobalDispatch, NavigateTo, UserSession, Id, Tag, Title, Text$, HasImageDesktop, HasImageMobile, ImageOnly, BackgroundColor, TextColor, UpdateTrigger, PreviewMode) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.UserSession = UserSession;
        this.Id = Id;
        this.Tag = Tag;
        this.Title = Title;
        this.Text = Text$;
        this.HasImageDesktop = HasImageDesktop;
        this.HasImageMobile = HasImageMobile;
        this.ImageOnly = ImageOnly;
        this.BackgroundColor = BackgroundColor;
        this.TextColor = TextColor;
        this.UpdateTrigger = (UpdateTrigger | 0);
        this.PreviewMode = PreviewMode;
    }
}

export function BannerProps_$reflection() {
    return record_type("Shared.Banner.BannerProps", [], BannerProps, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["UserSession", option_type(UserSession_$reflection())], ["Id", option_type(string_type)], ["Tag", string_type], ["Title", string_type], ["Text", string_type], ["HasImageDesktop", bool_type], ["HasImageMobile", bool_type], ["ImageOnly", bool_type], ["BackgroundColor", string_type], ["TextColor", string_type], ["UpdateTrigger", int32_type], ["PreviewMode", PreviewMode_$reflection()]]);
}

export class Model extends Record {
    constructor(SessionKey, Visible, GlobalDispatch, NavigateTo) {
        super();
        this.SessionKey = SessionKey;
        this.Visible = Visible;
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
    }
}

export function Model_$reflection() {
    return record_type("Shared.Banner.Model", [], Model, () => [["SessionKey", string_type], ["Visible", bool_type], ["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CloseDialog", "OpenNews"];
    }
}

export function Msg_$reflection() {
    return union_type("Shared.Banner.Msg", [], Msg, () => [[], []]);
}

export function State_sessionKey(props) {
    let copyOfStruct;
    return `banner-${defaultArg(props.Id, (copyOfStruct = newGuid(), copyOfStruct))}`;
}

export function State_init(props) {
    const alreadySeen = defaultArg(map((u) => containsKey(State_sessionKey(props), u.SessionData), props.UserSession), false);
    return [new Model(State_sessionKey(props), !alreadySeen, props.GlobalDispatch, props.NavigateTo), Cmd_none()];
}

export function State_update(msg, model) {
    if (msg.tag === 1) {
        model.NavigateTo(new Page(0, [1]));
        return [model, empty()];
    }
    else {
        model.GlobalDispatch(new GlobalMsg(7, [model.SessionKey, ""]));
        return [new Model(model.SessionKey, false, model.GlobalDispatch, model.NavigateTo), Cmd_none()];
    }
}

export function formatImageUrlDesktop(updateTrigger, id) {
    return `/api/banner/${id}/image/desktop?v${updateTrigger}`;
}

export function formatImageUrlMobile(updateTrigger, id) {
    return `/api/banner/${id}/image/mobile?v${updateTrigger}`;
}

export function imageUrlDesktop(hasImage, id, updateTrigger) {
    let matchResult;
    if (hasImage) {
        if (id != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return formatImageUrlDesktop(updateTrigger, id);
        default:
            return "";
    }
}

export function imageUrlMobile(hasImage, id, updateTrigger) {
    let matchResult;
    if (hasImage) {
        if (id != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return formatImageUrlMobile(updateTrigger, id);
        default:
            return "";
    }
}

export const bfsBanner = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Shared\\Banner.fs") + "#L") + int32ToString(value_2(89))) + ";") + "Shared.Banner.BannerProps", value_2("bfsBanner"), (props) => {
    let props_18, props_20, props_12, props_14;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, [props.UpdateTrigger]);
    const action = undefined;
    if (patternInput[0].Visible) {
        if (props.ImageOnly) {
            const props_26 = [new HTMLAttr(65, [`notification-tile banner-tile banner-image-only ${equals(props.PreviewMode, new PreviewMode(2, [])) ? "banner-preview-mobile" : ""}`]), ["style", {
                backgroundColor: props.BackgroundColor,
                color: props.TextColor,
                cursor: "pointer",
            }], new DOMAttr(40, [(_arg_2) => {
                patternInput[1](new Msg(1, []));
            }])];
            const children_21 = [(props_18 = [new HTMLAttr(65, ["banner-desktop"]), new HTMLAttr(149, [imageUrlDesktop(props.HasImageDesktop, props.Id, props.UpdateTrigger)])], react.createElement("img", keyValueList(props_18, 1))), (props_20 = [new HTMLAttr(65, ["banner-mobile"]), new HTMLAttr(149, [imageUrlMobile(props.HasImageMobile, props.Id, props.UpdateTrigger)])], react.createElement("img", keyValueList(props_20, 1))), bfsTile(react.createElement("span", {}), action, undefined, react.createElement("span", {}), undefined)];
            return react.createElement("div", keyValueList(props_26, 1), ...children_21);
        }
        else {
            let title;
            const children_9 = [(props.Tag.length > 0) ? react.createElement("div", {
                className: "notification-flag",
            }, props.Tag) : react.createElement("div", {
                className: "notification-flag-placeholder",
            }), react.createElement("div", {
                className: "mobile-spacer",
            }), react.createElement("div", {
                className: "notification-title-text",
            }, props.Title)];
            title = react.createElement("div", {
                className: "notification-title",
            }, ...children_9);
            const props_16 = [new HTMLAttr(65, [`notification-tile banner-tile ${props.HasImageDesktop ? "has-background-image-desktop" : ""} ${props.HasImageMobile ? "has-background-image-mobile" : ""} ${equals(props.PreviewMode, new PreviewMode(2, [])) ? "banner-preview-mobile" : ""}`]), ["style", {
                backgroundColor: props.BackgroundColor,
                color: props.TextColor,
            }]];
            const children_15 = [(props_12 = [new HTMLAttr(65, ["banner-background-container"]), ["style", {
                backgroundImage: `url('${imageUrlDesktop(props.HasImageDesktop, props.Id, props.UpdateTrigger)}'), url('${imageUrlMobile(props.HasImageMobile, props.Id, props.UpdateTrigger)}')`,
            }]], react.createElement("div", keyValueList(props_12, 1))), bfsTile(title, action, undefined, (props_14 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(props.Text)])], react.createElement("div", keyValueList(props_14, 1))), undefined)];
            return react.createElement("div", keyValueList(props_16, 1), ...children_15);
        }
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, undefined, undefined, "Of");

//# sourceMappingURL=Banner.fs.js.map
